export const environment = {
  production: false,
  env: 'Staging',
  ApiUrl: 'https://pcrbalancereportapitest.clavisco.com/',
  loginImage: '../../../assets/images/Polycenter_login.png',
  homeImage: '../../../assets/images/Polycenter_home.png',
  companyName : 'Polycenter'
};
